var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user && _vm.user.roles.includes('administrator'))?_c('a',{staticClass:"d-flex text-purple align-items-center mx-5",attrs:{"target":"_blank","href":`https://old-support.hrsys.pl/wp-admin/post.php?post=${_vm.id}&action=edit&trand=iHxmKppCluZD9v872ce4KoSrpwDlsmoc5VaWNmjJ`}},[_c('i',{staticClass:"fas fa-edit mr-1"}),_vm._v(" Edytuj ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }